angular.module('unica_material.material_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// MATERIAL
		.state('app.material', {
			url: '/material',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/material/templates/material.html',
					controller: 'MaterialBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

		// MATERIAL LIST
		.state('app.material.list', {
			url: '/list/:event_id',
			views: {
				'materialContent': {
					templateUrl: './modules/material/templates/list.html',
					controller: 'MaterialListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Lista Materiali',
				parent: function($scope) {
					return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + ' })';
				}
			}
		})

		// media_directory EDIT
		.state('app.material.edit', {
			url: '/edit/:event_id/:id',
			views: {
				'materialContent': {
					templateUrl: './modules/material/templates/edit.html',
					controller: 'MaterialEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Materiale',
				parent: 'app.material.list'
			}
		})

	;

});

